export const factoryRefs:{[key:string]:any} = {
    'Smeltery': {
        image: 'Buildings/SmelterMk1_256.png'
    },
    'Constructor': {
        image: 'Buildings/ConstructorMk1_256.png'
    },
    'Assembler': {
        image: 'Buildings/AssemblerMk1_256.png'
    },
    'Foundry': {
        image: 'Buildings/Foundry_256.png'
    },
    'Refinery': {
        image: 'Buildings/IconDesc_OilRefinery_256.png'
    },
    'Manufacturer': {
        image: 'Buildings/Manufacturer_256.png'
    },
    'Blender': {
        image: 'Buildings/IconDesc_Blender_256.png'
    },
    'Awesome Sink': {
        image: 'Buildings/ResourceSink_256.png'
    }
}